var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flip-card-reverse-button",on:{"click":function($event){return _vm.$emit('reverse-event')}}},[_c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.sideName))]),_c('v-icon',{attrs:{"color":"primary","x-large":""}},[_vm._v("flip ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }